import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTitle,
    ChartLegend,
    ChartValueAxis,
    ChartValueAxisItem
} from "@progress/kendo-react-charts";

import { useApiTrigger } from "../../hooks/useApiTrigger";
import { forwardRef, useImperativeHandle } from "react";

const SimpleBarChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || "Reporte_Grafica";
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    // Colores configurados
    const colors = data.color;

    // Generar datos con colores individuales
    const chartData = dto.map((item, index) => {
        let color;

        if (Array.isArray(colors) && colors.length > 0) {
            // Si solo hay un color, todas las barras usan ese color
            // Si hay varios, se asignan de forma secuencial
            color = colors[index % colors.length];
        }

        return {
            ...item,
            color
        };
    });

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />

            <ChartLegend
                position="top"
                orientation="horizontal"
            />

            <ChartCategoryAxis>
                <ChartCategoryAxisItem
                    categories={dto.map(item => item.category)}
                />
            </ChartCategoryAxis>

            <ChartValueAxis>
                <ChartValueAxisItem />
            </ChartValueAxis>

            <ChartSeries>
                <ChartSeriesItem
                    type="bar"
                    data={chartData}
                    field="value"
                    categoryField="category"
                    colorField="color"
                    tooltip={{ visible: true }}
                    labels={{
                        visible: true,
                        format: "{0}",
                        position: "outsideEnd"
                    }}
                />
            </ChartSeries>
        </Chart>
    );
});

export default SimpleBarChart;